import React from 'react';
import type { TextProps } from '@makemydeal/dr-ui-bricks-types';
import { StyledText } from './Text.style';

const Text: React.FC<TextProps> = ({ size = 'base', weight = 'regular', as, color, children, ...rest }) => (
    <StyledText as={as ?? 'p'} $size={size} $weight={weight} $color={color} {...rest}>
        {children}
    </StyledText>
);

export default Text;
